<!-- Card Container -->
<div class="card" [@simpleFadeAnimation]="'in'" style="height: auto !important">
  <div class="card-header flex justify-between items-center">
    <h3 class="card-title"> Account List</h3>
   </div>
<div kendoWindowContainer ></div>
<div kendoDialogContainer></div>
    <!-- Shown only on a cold load, while the full list downloads behind the
         first-page preview. Matters most with a filter active: results are
         incomplete until this clears. -->
    <div
      *ngIf="loadingAll"
      class="flex items-center gap-2 mx-4 mb-2 px-3 py-2 rounded border border-amber-300 bg-amber-50 text-amber-800"
      style="font-size: small"
    >
      <span class="k-icon k-i-loading"></span>
      <span *ngIf="hasActiveFilter">
        Searching the full account list - still loading, so results may be
        incomplete for a moment.
      </span>
      <span *ngIf="!hasActiveFilter">
        Showing the first {{ previewRowCount }} accounts - loading the full list...
      </span>
    </div>
    <!-- gridHeight: the grid shrinks to fit a short page of rows, and stops above
         the footer (scrolling inside the grid, pager visible) for a long one. -->
    <div class="card overflow-hidden" id="pendingtgrid" #gridContainer>
      <kendo-grid
        #grid
        [style.height.px]="gridHeight"
        [loading]="loading"
        [kendoGridBinding]="viewer"
        [pageable]="true"
        [pageSize]="pageSize"
        [sortable]="true"
        [filterable]="true"
        [sort]="state.sort"
        [resizable]="true"
        [selectable]="true"
        [navigable]="true"
        (filterChange)="filterChange($event)"
        (sortChange)="sortChange($event)"
        (dataStateChange)="dataStateChange($event)"
      >
        <ng-template kendoGridToolbarTemplate>
          <button
            *ngIf="NeedRolePermission"
            type="button"
            class="k-button"
            [svgIcon]="folderExcel"
            [disabled]="loadingAll"
            title="{{ loadingAll ? 'Waiting for the full account list...' : 'Export to Excel' }}"
            (mouseenter)="onMouseEnter()"
            (click)="startinit()"
            (mouseleave)="onMouseLeave()"
            kendoGridExcelCommand
          >
            Export to Excel
          </button>
        </ng-template>

        <!-- Dynamic Columns -->
        <kendo-grid-column
          *ngFor="let column of columns"
          [field]="column.field"
          [title]="column.title"
          [width]="column.width"
          [filterable]="column.filterable"
          [filter]="column.filter"
          [hidden]="column.hidden"
          [format]="column.format"
          [ngSwitch]="column.template"
        >
          <ng-template *ngSwitchCase="'date'" kendoGridCellTemplate let-dataItem>
            {{ dataItem[column.field] | date : 'MM/dd/yyyy' }}
          </ng-template>
          <ng-template *ngSwitchCase="'checkbox'" kendoGridCellTemplate let-dataItem>
            <input type="checkbox" [checked]="dataItem[column.field]" disabled />
            {{ dataItem[column.field] }}
          </ng-template>
        </kendo-grid-column>

        <!-- Action Columns -->
        <kendo-grid-column [width]="40">
          <ng-template kendoGridCellTemplate let-dataItem>
            <a
              (click)="viewTransactions(dataItem.clientId, dataItem.repId)"
              routerLinkActive="router-link-active"
              title="Add a Transaction"
              class="icon-btn"
            >
              <ng-icon name="heroDocumentDuplicate" class="xl"></ng-icon>
            </a>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column [width]="45">
          <ng-template kendoGridCellTemplate let-dataItem>
            <a
              (click)="viewClientInfo(dataItem.clientId)"
              title="View Client"
              class="icon-btn"
            >
              <ng-icon name="heroUsers" class="xl"></ng-icon>
            </a>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column [width]="40">
          <ng-template kendoGridCellTemplate let-dataItem>
            <a
              (click)="EditAccount(dataItem.clientId)"
              routerLinkActive="router-link-active"
              title="Edit Client"
              class="icon-btn"
            >
              <ng-icon name="heroPencil" class="xl"></ng-icon>
            </a>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column [width]="40">
          <ng-template kendoGridCellTemplate let-dataItem>
            <a
              (click)="viewTransactionsList(dataItem.repId, dataItem.clientId)"
              routerLinkActive="router-link-active"
              title="View Transactions"
              class="icon-btn"
            >
              <ng-icon name="heroDocumentText" class="xl"></ng-icon>
            </a>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column [width]="40">
          <ng-template kendoGridCellTemplate let-dataItem>
            <a
              (click)="viewFiles(dataItem.repId, dataItem.clientId, dataItem.lastName, dataItem.firstName)"
              title="View Files"
              routerLinkActive="router-link-active"
              class="icon-btn"
            >
              <ng-icon name="heroFolder" class="xl"></ng-icon>
            </a>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column [width]="40">
          <ng-template kendoGridCellTemplate let-dataItem>
            <a
              (click)="onDialogOpenWord(dataItem.clientId)"
              routerLinkActive="router-link-active"
              title="Create change of Dealer Fax"
              class="icon-btn"
            >
              <ng-icon name="heroMegaphone" class="xl"></ng-icon>
            </a>
          </ng-template>
        </kendo-grid-column>

        <!-- Excel Export Definitions -->
        <kendo-grid-excel fileName="Account_list.xlsx" [fetchData]="allData">
          <!-- ... all your kendo-excelexport-column definitions ... -->
        </kendo-grid-excel>
      </kendo-grid>
    </div>

    <!-- Notes Dialog -->
    <kendo-dialog
      [title]="noteheader"
      *ngIf="openednotes"
      (close)="onDialogClosenotes()"
      [width]="850"
    >
      <gd-rep-editor-log
        [clientidpassed]="readingClientId"
        [accountname]="readaccountname"
      >
      </gd-rep-editor-log>
      <kendo-dialog-actions>
        <button class="k-button w-full" (click)="onDialogClosenotes()">Close</button>
      </kendo-dialog-actions>
    </kendo-dialog>

    <!-- Sponsor Selection Dialog -->
    <kendo-dialog
      title="Choose a Sponsor"
      *ngIf="openworddocselection"
      (close)="onDialogClose()"
      [width]="850"
      class="p-6"
    >
      <div class="space-y-4 text-center">
        <div>
          <label class="font-medium">Insurance Product Fax</label>
          <kendo-dropdownlist
            [textField]="'sponsorName'"
            [valueField]="'sponsorID'"
            [data]="sponsorinsurancelist"
            (selectionChange)="selectioninsuranceevent($event)"
            class="w-80 mx-auto"
          ></kendo-dropdownlist>
        </div>
        <div>
          <label class="font-medium">Trading Product Fax</label>
          <kendo-dropdownlist
            [textField]="'sponsorName'"
            [valueField]="'sponsorID'"
            [data]="sponsortradingfaxlist"
            (selectionChange)="selectionfaxevent($event)"
            class="w-80 mx-auto"
          ></kendo-dropdownlist>
        </div>
        <kendo-dialog-actions class="flex space-x-4">
          <button
            class="k-button border border-gray-300 w-full"
            (click)="Submit()"
            [disabled]="aftersubmit"
          >
            Submit
          </button>
          <button class="k-button border border-gray-300 w-full" (click)="onDialogClose()">
            Close
          </button>
        </kendo-dialog-actions>
      </div>
    </kendo-dialog>
  </div>

